import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from "react";
import { MouseEvent, useEffect, useState } from "react";
import { isEnabled } from "common/components/Didomi";
import { linkClassNames } from "common/components/Footer";

/**
 * Renders Didomi's consent preferences link.
 * It renders nothing until Didomi is enabled, has finished loading, and the
 * visitor is under a consent regulation (mirrors the equivalent Stimulus
 * controller: rails/app/assets/javascripts/controllers/didomi_preferences_controller.js).
 */
export const ConsentPreferencesLink = t0 => {
  "use memo";

  const $ = _c(5);
  const {
    title,
    children
  } = t0;
  const [isReady, setIsReady] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (!isEnabled()) {
        return;
      }
      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(() => {
        if (window.Didomi.getCurrentUserStatus().regulation !== "none") {
          setIsReady(true);
        }
      });
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!isEnabled() || !isReady) {
    return null;
  }
  const onClick = _temp;
  let t3;
  if ($[2] !== children || $[3] !== title) {
    t3 = <a title={title} href="#" onClick={onClick} className={linkClassNames}>{children}</a>;
    $[2] = children;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(event) {
  event.preventDefault();
  window.Didomi.preferences.show();
}